import React from 'react';
import { Link } from 'react-router-dom';
import { Layout } from '../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../components/shared';
import { ArrowRight } from 'lucide-react';

export const MedicumPage = () => {
  return (
    <Layout>
      <PageHero
        title="Das Medicum-Konzept – Medizin vernetzt denken"
        subtitle="Hausärzte und Fachärzte unter einem Dach – kurze Wege, schnelle Entscheidungen."
        backgroundImage="/images/Das_Medicum_Prinzip.webp"
        showCTA={false}
      />

      <ContentSection
        title="Ein Ärztezentrum als Einheit"
        content="Im Medicum Diez arbeiten mehrere Fachrichtungen eng zusammen. Diagnostik und Therapie werden direkt abgestimmt."
        image="/images/Aerztezentrum_Einheit_opt.webp"
        backgroundColor="white"
      />

      <ContentSection
        title="Koordination durch den Hausarzt"
        content="Als erste Ansprechpartner bündeln wir Befunde, organisieren Überweisungen und begleiten Ihre Behandlung fachübergreifend."
        image="/images/Medizin_aus_Ueberzeugung.webp"
        imagePosition="left"
        backgroundColor="gray"
      />

      <ContentSection
        title="Moderne Diagnostik im Haus"
        content={
          <div>
            <p className="text-[#0b382a]/80 leading-relaxed mb-4">
              Offenes MRT, Ultraschall, Herzdiagnostik und Labor stehen zentral zur Verfügung – mit schneller Befundung und direkter Rücksprache.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link to="/leistungen/diagnostik" className="inline-flex items-center gap-2 text-[#b5a05f] hover:text-[#9a8850] font-medium transition-colors">
                Diagnostik-Zentrum
                <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/leistungen/kardiologie" className="inline-flex items-center gap-2 text-[#b5a05f] hover:text-[#9a8850] font-medium transition-colors">
                Kardiologie & Herz-Check
                <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/leistungen/diagnostik/mrt" className="inline-flex items-center gap-2 text-[#b5a05f] hover:text-[#9a8850] font-medium transition-colors">
                Offenes MRT
                <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        }
        image="/images/MRT 5.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Ärztezentrum Medicum Diez"
        content="Das Medicum Diez ist ein fachübergreifendes Ärztezentrum mit Hausärzten, Kardiologie, Radiologie und weiteren Fachrichtungen. Patienten profitieren von koordinierter Medizin an einem Standort."
      />

      <CTASection
        title="Termin im Medicum Diez vereinbaren"
        subtitle="Profitieren Sie von kurzen Wegen und abgestimmter Medizin."
        buttonText="Jetzt Termin buchen"
      />
    </Layout>
  );
};

export default MedicumPage;
